<template>
  <div :class="['brand-logo', { 'brand-logo--dark': dark }]">
    <img
      class="brand-logo__asset"
      :src="assetSrc"
      alt="ComplyOps"
      :width="assetSize.width"
      :height="assetSize.height"
    >

    <span v-if="caption && !markOnly" class="brand-logo__copy">
      <small v-if="caption">{{ caption }}</small>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BrandLogo',
  props: {
    caption: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    markOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    assetSrc () {
      if (this.markOnly) {
        return this.dark ? '/brand/complyops-mark-white.svg' : '/brand/complyops-mark.svg'
      }

      return this.dark ? '/brand/complyops-logo-white.svg' : '/brand/complyops-logo.svg'
    },
    assetSize () {
      return this.markOnly
        ? { width: 239, height: 160 }
        : { width: 1034, height: 160 }
    }
  }
}
</script>
